import React from 'react';
import { Link } from 'react-router';
import styles from './styles.scss';

function ChargeSoLittle () {
  return (
    <div className="row">
      <div className="col-md-9 col-center">
          <h1 className="bold-italics blue text-center mb50">
            How can you charge as little as $10k for an app design?
          </h1>
          <p className="ls1">
            <span className="bold">Welcome to the future of design. </span>
            Thanks to crazy-good communication devices and apps, we're now
            able to run a seamless design team remotely. This means
            <span className="bold"> you get access to A+ designers for a fraction of the cost </span>
            of big agencies or hiring full time.
          </p>
          <p className="ls1 mt30 mb50">
            <span className="bold">And, our designers are eager to help! </span>
            They come to DesignCue looking for extra income and engaging
            challenges. Their passion for design directly benefits every startup
            we work with.
          </p>
          <Link to='/get-started' className={`${styles.choose} btn btn-dc-primary btn-xs-block`}>
            SUBMIT A BRIEF
          </Link>
      </div>
    </div>
  );
}

export default ChargeSoLittle;



// WEBPACK FOOTER //
// ./src/components/ChargeSoLittle/index.js